<script lang="ts">
  import { Form, TextField, Flex, Button } from "@gl/design-system"

  export let keyValues: object = {}
  export let readonly: boolean = false
  export let keyPlaceholder: string = ""
  export let valuePlaceholder: string = ""

  let key;
  let value;
</script>

<Form>
  {#each Object.entries(keyValues) as [key, value] }
  <Flex style="align-items: flex-start;">
    <TextField {readonly} bind:value={key} placeholder={keyPlaceholder} on:change={(a) => {delete keyValues[key]; keyValues[a.target.value] = value; keyValues = keyValues}}/>
    <TextField {readonly} bind:value={value} placeholder={valuePlaceholder} on:change={(a) => {keyValues[key] = a.target.value == '' ? null : a.target.value; keyValues = keyValues}}></TextField>
    <Button style="margin-left: 0.5rem" status="error" on:click={() => {delete keyValues[key]; keyValues = keyValues}}>-</Button>
  </Flex>
  {/each}
  {#if !readonly}
  <Flex style="align-items: flex-start;">
    <TextField bind:value={key} placeholder={keyPlaceholder}/>
    <TextField bind:value={value} placeholder={valuePlaceholder}></TextField>
    <Button style="margin-left: 0.5rem" on:click={() => {keyValues[key] = value; key = null; value = null;}}>Add</Button>
  </Flex>
  {/if}
</Form>